const LOCAL_STORAGE_KEY = "translations"
import { load, store } from "./localStorage"
import _ from "lodash"

export default {
  async onInit() {
    const data = await load(LOCAL_STORAGE_KEY)

    const translationToken = hashParams.get("translation_token")
    const translationId = hashParams.get("id")

    this.values = {
      token: translationToken,
      translationId: translationId,
      translation: null,
    }

    if (data) {
      this.values.translation = data.values.translation
    } else {
      await this.pull()
    }

    if (translationToken && translationId) {
      this.enableEdit()
      await this.pull()
    }
  },

  async pull() {
    const params = this.values.translationId ? `${this.values.translationId}/` : ""
    const apiUrl = pipelineConfig.orderApiUrl.replace("order", params + "translation")

    await fetch(apiUrl, {
      method: "GET",
      headers: {
        "content-type": "application/json",
        "x-token": this.values.token || null,
      },
    })
      .then((response) => response.json())
      .then((res) => {
        if (res.error) {
          $(".error").html(res.error)
        } else {
          this.values.translation = res.data
          Alpine.effect(() => {
            store(LOCAL_STORAGE_KEY, { values: this.values })
          })
        }
      })
  },

  enableEdit() {
    const values = this.values
    const push = this.push

    $("body").prepend(`
        <div class="w-full h-16 bg-white flex justify-between content-center p-2 sticky top-0 z-10" x-data="{ active: false }">
          <button class="rounded-full px-4 py-2 text-white" :class="active ? 'bg-green-800' : 'bg-green-500'" x-on:click="active = true; setTimeout(() => { active = false }, 1000)">Save Changes</button>
          <div class="error text-red-700"></div>
          <div class="message text-green-600"></div>
        </div>`)

    $(".editable")
      .prop({ tabindex: 1, contenteditable: true })
      .on({
        focusin() {
          this.__html = $(this).html() // Store current HTML content
        },

        focusout() {
          const data = {
            attr: $(this).attr("x-html"),
            html: this.innerHTML,
          }

          if (this.__html === data.html) return // Nothing has changed.

          const pageKey = data.attr.split(data.attr.includes("`") ? "`" : "'")[1].split(".")

          _.set(values.translation, pageKey, data.html)

          push(values)
        },
      })

    $(document).on("paste", ".editable", function (e) {
      e.preventDefault()

      const clean = e.originalEvent.clipboardData.getData("Text").replace(/<(.|\n)*?>/g, "")

      const selection = window.getSelection()

      if (!selection.rangeCount) return false
      selection.deleteFromDocument()
      selection.getRangeAt(0).insertNode(document.createTextNode(clean))
    })
  },

  async push(values) {
    const apiUrl = pipelineConfig.orderApiUrl.replace(
      "order",
      `${values.translationId}/translation`
    )
    const options = {
      method: "PATCH",
      headers: {
        "content-type": "application/json",
        "x-token": values.token,
      },
      body: JSON.stringify({
        ...values.translation,
      }),
    }

    const res = await fetch(apiUrl, options)
    const response = await res.json()

    if (response.error) {
      $(".message").text("")
      $(".error").text(response.error)
    } else {
      values.translation = response.data
      $(".message").text("Changes saved")
    }
  },
}
